export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PEER_DATA = 'SET_PEER_DATA';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_IP_ADDRESS = 'SET_IP_ADDRESS';
export const SET_CS_DATA = 'SET_CS_DATA';
export const SET_BD_DATA = 'SET_BD_DATA';
export const SET_AUDIT_DATA = 'SET_AUDIT_DATA';




// WEBPACK FOOTER //
// ./src/store/modules/user/user-mutation-types.js